import { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/use-api';
import { moduleClientFactory } from '../../../api-service/module-client-factory';
import { ICitizenLookup } from './interfaces';

interface InputParams {
  input: string;
  fetchMinimumInputLength: number;
  initialValue?: ICitizenLookup[];
}

export const useFetch = (params: InputParams) => {
  const { input, fetchMinimumInputLength, initialValue } = params;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [data, setData] = useState<ICitizenLookup[]>(initialValue || []);

  const lookupClient = moduleClientFactory.createLookupCitizenClient();
  const citizenLookupApi = useApi((cancelToken, query: string) => lookupClient.getCitizensByLookupQuery({ query: query }), { citizens: [] });

  useEffect(() => {
    if (input.length >= fetchMinimumInputLength) {
      setLoading(true);

      const search = async () => {
        try {
          const response = await citizenLookupApi.invoke(input);
          setData(response.result.citizens || []);
        } catch (err: any) {
          setError(err);
        } finally {
          setLoading(false);
        }
      };
      search();
    } else {
      setData(initialValue || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input]);

  return { loading, data, error };
};
